import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DistancePipe } from './pipes/distance.pipe';



@NgModule({
  declarations: [DistancePipe],
  imports: [
    CommonModule
  ],
  exports: [DistancePipe],
  providers: [DistancePipe]
})
export class SharedModule { }
